import { storeDeps } from "./deps";
import {
  createAuthStore,
  createWorkspaceStore,
  createLogStore,
  createAdjustmentStore,
  createCategoryStore,
  createMethodStore,
  createInvitationStore,
  createNotificationStore,
  createNotificationSettingStore,
  createSpendingGoalStore,
  createStatsStore,
} from "@repo/share-log-stores";

export const useAuthStore = createAuthStore(storeDeps);
export const useWorkspaceStore = createWorkspaceStore(storeDeps);
export const useLogStore = createLogStore(storeDeps);
export const useAdjustmentStore = createAdjustmentStore(storeDeps);
export const useCategoryStore = createCategoryStore(storeDeps);
export const useMethodStore = createMethodStore(storeDeps);
export const useInvitationStore = createInvitationStore(storeDeps);
export const useNotificationStore = createNotificationStore(storeDeps);
export const useNotificationSettingStore = createNotificationSettingStore(storeDeps);
export const useSpendingGoalStore = createSpendingGoalStore(storeDeps);
export const useStatsStore = createStatsStore(storeDeps);

export type {
  AuthStore,
  WorkspaceStore,
  LogStore,
  AdjustmentStore,
  CategoryStore,
  MethodStore,
  InvitationStore,
  NotificationStore,
  NotificationSettingStore,
  SpendingGoalStore,
  StatsStore,
} from "@repo/share-log-stores";
